module.exports = __webpack_public_path__ + "img/app-yqs1.9b832f07.png";